<template>
  <full-container>
    <el-alert slot="header" title="角色的顺序号很重要，用于组合角色时数据规则的判定。" type="warning" show-icon />
    <el-table v-loading="loading" ref="tb" :data="datalist" height="100%">
      <el-table-column prop="Sort" label="#" width="60" align="center" />
      <el-table-column prop="Name" label="角色名称" min-width="100" />
      <el-table-column prop="Describe" label="简介" min-width="240" />
      <el-table-column label="操作" width="100" align="center">
        <el-link slot="header" type="primary" icon="el-icon-plus" @click="openForm()">新增</el-link>
        <el-dropdown slot-scope="{ row }">
          <el-tag size="small" :type="row.State ? 'primary' : 'danger'">
            {{ row.State ? '启用' : '禁用' }}
            <i class="el-icon-arrow-down" />
          </el-tag>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="openForm(row.Id)">修改信息</el-dropdown-item>
            <el-dropdown-item @click.native="onDelete(row.Id)">删除角色</el-dropdown-item>
            <el-dropdown-item v-action="'/api/System/Authorize/GetActions'" @click.native="$router.push({ path: `permit/1/${row.Id}` })">角色授权</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-table-column>
    </el-table>
  </full-container>
</template>

<script>
import form from './form'
export default {
  data () {
    return {
      datalist: [],
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    // 信息列表
    loadData () {
      if (this.loading) {
        return
      }
      this.loading = true
      return this.$apis.system.role.getList().then((res) => {
        this.loading = false
        this.datalist = res
      })
    },
    //编辑
    openForm (id) {
      this.$layer.iframe({
        title: '角色表单',
        area: ['420px', 'auto'],
        content: {
          content: form,
          parent: this,
          data: { id: id },
        },
      })
    },

    //删除
    onDelete (id) {
      if (this.loading) {
        return
      }
      this.$confirm('此操作将永久删除数据, 是否继续', '删除角色', {
        center: true,
      }).then(() => {
        this.loading = true
        this.$apis.system.role.delete({ id: id }).then(() => {
          this.loading = false
          this.loadData()
          this.$message({ message: '数据删除成功！', type: 'success' })
        }).catch((e) => {
          this.$message.error(e || '数据删除失败')
        }).finally(() => {
          this.loading = false
        })
      })
    },
  },
}
</script>
